import {h} from "preact";

import "./Webcam.scss";
import {forwardRef} from "preact/compat";
import {useState, useEffect} from "preact/hooks";



const WebcamScreen = forwardRef<HTMLDivElement>((props, ref) => {
    const [camURL, setCamURL] = useState("https://ury.org.uk/webcam/view/live");

    useEffect(() => {
        let timer: number;
        const updateCamURL = () => {
            setCamURL("https://ury.org.uk/webcam/view/live?" + Date.now());
            timer = setTimeout(updateCamURL, 1000);
        };
        timer = setTimeout(updateCamURL, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div class="webcam-card card" ref={ref}>
            <h2 class="header-sideline" title="Webcam from our Studios">
                <span class="btn header">
                    Webcam
                </span>
                <span class="sideline">from our Studios</span>
            </h2>
            <div>
                <img src={camURL} alt="Studio Webcam image" />
            </div>
        </div>
    )
});
export default WebcamScreen;
